module.exports = __webpack_public_path__ + "static/media/get_10pt.51ec0b2d.png";